
/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { Map } from 'immutable';
import type { IndicatorMetadata } from './types';
import {getCurrentEntityTypes, getEntityTypes} from '../miscellaneous/getters';

export const indicatorTags = getterFromKeyPath(['indicators', 'tags', 'data']);
export const indicatorTagsLoading = getterFromKeyPath(['indicators', 'tags', 'loading']);
export const indicatorList = getterFromKeyPath(['indicators', 'library', 'indicatorList']);
export const indicatorListLoading = getterFromKeyPath(['indicators', 'library', 'loading']);
export const fetchParams = getterFromKeyPath(['indicators', 'library', 'fetchParams']);
export const currentDisplayRange = getterFromKeyPath(['indicators', 'library', 'currentDisplayRange']);
export const metadata = getterFromKeyPath(['indicators', 'metadata']);
export const enrichment = getterFromKeyPath(['indicators', 'enrichment']);
export const fetchingTagIndicators = getterFromKeyPath(['indicators', 'tagCollection', 'loading']);
export const tagIndicators = getterFromKeyPath(['indicators', 'tagCollection', 'indicators']);
export const enrichmentLoading = getterFromKeyPath(['indicators', 'enrichment', 'loading']);
export const exportLoading = getterFromKeyPath(['indicators', 'exportLoading']);

/* Provide metadata for a given indicator by its id: type|value */
export const metadataByIndicator = (indicatorId: string): (state: Map<string, any>) => ?IndicatorMetadata => createSelector(
  metadata,
  (metadata: Map<string, IndicatorMetadata>): IndicatorMetadata | null => {
    return metadata.get(indicatorId) || null;
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/indicators/getters.js